export const otp1 = 'oi-1';
export const otp2 = 'oi-2';
export const otp3 = 'oi-3';
export const otp4 = 'oi-4';
export const otp5 = 'oi-5';
export const otp6 = 'oi-6';
